import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  height: 100%;
  margin-left: -10px;
`

export const StyledTooltip = styled.div`
  position: absolute;
  top: 12px;
  left: 12px;
  display: none;
  padding: 8px;
  z-index: 5;
  pointer-events: none;
  border: 0.5px solid #eff0fa;
  border-radius: 4px;
  background: #fafafc;
  font-weight: 400;
  font-size: 11px;
  line-height: 140%;
  color: #2c2842;
`

export const StyledMobileTooltip = styled.div`
  display: none;
  background: #fafafc;
  border: 0.5px solid #eff0fa;
  border-radius: 4px;
  margin: 12px 0 0 10px;
  padding: 4px;
`

export const MiniChartContainer = styled.div`
  position: relative;
  width: 83px;
  height: 100%;
`
